import { useCurrentEnterprise } from '@mews-commander/legacy-entities/src/enterprise';
import { Amount, GeneralPricingMode } from '@mews-commander/data-access';
import { WithServiceId } from '@mews-commander/types';
import { LocalizedEnum } from '@mews/framework';
import { ConvertedCurrencyValue, SpacedForwardSlash } from '@mews-commander/ui';
import { useService } from '@mews-commander/legacy-entities/src/utils/useService';
import { isBookableService } from '@mews-commander/legacy-entities/src/ducks/servicesNew';

interface SecondaryPriceTextProps extends WithServiceId {
    price: Amount | undefined;
}

export const SecondaryPriceText: React.FC<SecondaryPriceTextProps> = ({ price, serviceId }) => {
    const enterprise = useCurrentEnterprise();
    const service = useService(serviceId);

    const isMultiTaxEnvironment = enterprise.pricing === GeneralPricingMode.Net;

    if (!price || !service || !isBookableService(service)) {
        return null;
    }

    return (
        <span>
            <ConvertedCurrencyValue amount={price} net={isMultiTaxEnvironment} />
            {SpacedForwardSlash}
            <LocalizedEnum prefix="TimeUnitPeriod" value={service.data.value.timeUnitPeriod} />
        </span>
    );
};
